import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  categories: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
    flex: 1,
    minWidth: 0,
  },
  category: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    fontWeight: 500,
    '&:not(:last-child)::after': {
      content: '"•"',
      marginLeft: theme.spacing(0.5),
    },
  },
  categoryExtra: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.main,
    cursor: 'default',
    borderRadius: 4,
    padding: theme.spacing(0, 0.5),
    backgroundColor: theme.palette.primary.light,
  },
  metaEnd: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  lessonCount: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  statusChip: {
    fontWeight: 'bold',
    flexShrink: 0,
  },
  activeStatus: {
    color: theme.palette.statusLabel.success.primary,
    backgroundColor: theme.palette.statusLabel.success.secondary,
  },
  inativeStatus: {
    color: theme.palette.statusLabel.warning.primary,
    backgroundColor: theme.palette.statusLabel.warning.secondary,
  },
  deletedStatus: {
    color: theme.palette.statusLabel.softDeleted.secondary,
    backgroundColor: theme.palette.statusLabel.softDeleted.primary,
  },
  title: {
    fontSize: 15,
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.4,
  },
  info: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  infoIcon: {
    color: theme.palette.text.secondary,
  },
  infoText: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  downloadButton: {
    textTransform: 'none',
    borderRadius: 6,
    fontWeight: 600,
    marginTop: 'auto',
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))

export default useStyles
